module.exports = __webpack_public_path__ + "assets/img/zs03.b45174eb.png";